import type { INotificationRule, INotificationRuleTemplate } from '@condo/domain';
import { omit } from 'lodash';
import { getClient } from '@/shared/api/client';

export const getUserNotificationRules = async (userUid: string, notificationRuleTemplateId?: number): Promise<INotificationRule[]> => {
    const { data } = await getClient('basecamp').get<{ notificationRules: INotificationRule[] }>('/notification/notification-rules', {
        params: { notificationRuleTemplateId, userUid },
    });
    return data?.notificationRules ?? [];
};

export const getNotificationRuleTemplates = async (): Promise<INotificationRuleTemplate[]> => {
    const { data } = await getClient('basecamp').get<{ notificationRuleTemplates: INotificationRuleTemplate[] }>('/notification/notification-rule-templates');
    return data?.notificationRuleTemplates ?? [];
};

export const updateNotificationRule = async (notificationRule: INotificationRule): Promise<INotificationRule> => {
    const { data } = await getClient('basecamp').put<{ notificationRule: INotificationRule }>(
        `/notification/notification-rules/${notificationRule.notificationRuleId}`,
        {
            notificationRule: omit(notificationRule, ['notificationRuleId', 'updatedAt', 'createdAt']),
        },
    );
    return data.notificationRule;
};

export const deleteNotificationRule = async (notificationRuleId: number): Promise<void> => {
    await getClient('basecamp').delete(`/notification/notification-rules/${notificationRuleId}`);
};

export const deleteNotificationRuleForUser = async (userUid: string): Promise<void> => {
    await getClient('basecamp').delete(`/notification/notification-rules/user/${userUid}`);
};

export const generateNotificationRule = async (
    rules: { templateName: string; tokens: Record<string, unknown> }[],
    user?: { uid: string; email?: string },
): Promise<INotificationRule[]> => {
    const { data } = await getClient('basecamp').post<{ notificationRules: INotificationRule[] }>('/notification/notification-rules', { rules, user });
    return data?.notificationRules ?? [];
};
